<template>

<div class="ratatatatatatatatatatatata">
  <slick ref="slick" :options="slickOptions" >
    <!-- <div v-for="artefact in artefacts" :key="artefact._id"> -->
    
            <slot> </slot>
<!-- </div> -->
</slick>
</div>
</template>


<script>
import Slick from "vue-slick";

export default {
      components: { Slick },
      props:['unslick'],
  data () {
      return { 
        slickOptions: {
        dots: true,
        // centerMode: true,
        infinite: true,
        arrows: true,
        speed: 1400,
        slidesToShow:3,
        slidesToScroll: 1,
        responsive: [
          // {
          //   breakpoint: 1224,
          //   settings: {
          //     slidesToShow: 3,
          //     slidesToScroll: 3,
          //     arrows: false,
          //     infinite: true,
          //     dots: false
          //   }
          // },
          {
            breakpoint: 1380,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
     
            }
          },
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false,
              infinite: true,
              arrows: false
            }
          },
          {
            breakpoint: 530,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              infinite: true,
              arrows: false
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      },
      }
  },
  methods: {
      next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      })
  }
  },
    mounted () {
     // this.moveButton(this.isAdmin);
     this.reInit();
    },
    updated(){
      this.reInit();
    }
}
</script>


<style >


/* .card__media__background:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: none;
  opacity: 1;
} */
.curved {
  border-bottom-right-radius: 40% 10%;
  border-bottom-left-radius: 50% 10%;
}

#myImg:hover,
#myImg2:hover,
#myImg3:hover,
#myImg4:hover,
#myImg5:hover,
#myImg6:hover {
  opacity: 0.7;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 50; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  left: -27px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
  background-color: transparent;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

.icon-circle {
  border-radius: 32px;
}

.pdfText {
  text-decoration: none;
  color: black !important;
  outline: none;
}

.pdfDate {
  font-size: 0.8em;
  color: grey;
}

.uploadedFilesText {
  color: grey;
}

.headerIcons {
  position: absolute;
  top: 6%;
  right: 4%;
}

.description p {
  text-align: justify;
}
html,
body {
  margin: 0;
  padding: 0;
}
* {
  box-sizing: border-box;
}
.slider {
  width: 50%;
  margin: 100px auto;
}
.slick-slide {
  margin: 0px 20px;
}
.slick-slide img {
  width: 100%;
}

.slick-slide {
  transition: all ease-in-out 0.3s;
  opacity: 1;
}

.slick-active {
  opacity: 1;
}
.slick-current {
  opacity: 1;
}
.ratatatatatatatatatatatata  .slick-prev:before,
.ratatatatatatatatatatatata  .slick-next:before {
  color: white !important;
}

@media screen and (max-width:530px) {
  .slick-slide {
  transition: all ease-in-out 0.3s;
  opacity: 0.2;
}

.slick-active {
  opacity: 0.5;
}
.slick-current {
  opacity: 1;
}
  
}

.group-title{
  color:white;
    font-size: 2.2em !important;
    top:3%;
}

.group-subheading { 
  position: absolute;

        font-size: 1.06em !important;
    top: 101%;
        left: 4%;
        color: white;

}

.collection-title { 
  color:black;
    font-size: 2em !important;
    top:3%;
}

.collection-subheading {
    position: absolute;

        font-size: 1.06em !important;
    top: 101%;
        left: 4%;
        color: black;

}

.headline {

      -webkit-text-stroke-width: 0.3px;
    -webkit-text-stroke-color: black;
}


.overlay-image {  

  position:absolute; 
  background-color: rgba(0,0,0,0.5); 
  width:100vw; 
  height:100%;
}
</style>


<style  src='@/../static/slick-theme.css'>

</style>



<style scoped>


.headline-artefact {
    position: absolute;
    bottom: 3%;
    left: 3%;
    -webkit-text-stroke-width: 0.3px;
    -webkit-text-stroke-color: black;
  }
  .div1 { 
    position:absolute; width:67%; top: 4%;
  }

  .hrstl { 
    color:#efefef; border-style:solid;
  }

  .spanstl { 
    color:#B0B0B0;
  }

  .hrstl2 {
    color:#ddd; border-style:solid;
  }

  .div2 { 
    position:absolute; width:100%; top: 9%;
  }

  .hrstl3 { 
    color:#efefef; border-style:solid;
  }

  .pstl {
    color:#B0B0B0;
  }

  .hrstl4 {
    color:#ddd; border-style:solid;
  }

  .div3 { 
    position:absolute; width:67%; top: 4%;
  }

  .group-div {
    width: 100%;
    top:6% !important;
  }


</style>


// WEBPACK FOOTER //
// src/components/Partials/Slider3.vue